import React from "react";
import i18n from "i18n/i18n";
import { isPlayEnv } from "helpers/helper";
import DnaAnimation from "./DnaAnimation";
import "./SRMSyncLoader.scss";

const SRMSyncLoader = ({ message = "" }) => {
  const renderPlayEnv = () => {
    return (
      <>
        <p className="srm-sync-loader__main-content">
          Your Play environment data is currently being refreshed.
        </p>
        <p className="srm-sync-loader__sub-content">
          This may take some time,
          <br />
          depending on the size of your data.
        </p>
        <DnaAnimation />
      </>
    );
  };

  const renderGeneral = () => {
    return (
      <>
        <p>{message || i18n.t("texada_web_needs_to_synchronize_your_account_data_with_srm")}</p>
        <DnaAnimation />
        <p>{i18n.t("this_may_take_a_few_minutes_thank_you_for_your_patience")}</p>
      </>
    );
  };

  return (
    <div className="srm-sync-loader">
      {isPlayEnv() ? renderPlayEnv() : renderGeneral()}
    </div>
  );
};

export default SRMSyncLoader;
